/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Event Bus using pub/sub design pattern
 */
// TODO

import _ from 'lodash';
import log from 'loglevel';
import { faro, LogLevel } from '@grafana/faro-web-sdk';

/**
 * Events
 */
enum Events {
	Loading = 'M_LOADING',
	Warn = 'M_WARN',
	Info = 'M_INFO',
	Success = 'M_SUCCESS',
	Error = 'M_ERROR',

	N_Loading = 'N_LOADING',
	N_Warn = 'N_WARN',
	N_Info = 'N_INFO',
	N_Success = 'N_SUCCESS',
	N_Error = 'N_ERROR',

	M_Success = 'MO_SUCCESS',
	M_Error = 'MO_ERROR',
	M_Info = 'MO_INFO',
	M_Warn = 'MO_WARN',

	Land = 'APP_LAND',
	Api_Error = 'APP_API_ERROR',
	Redirect = 'APP_REDIRECT',
}

enum Messages {
	Success = 'Success',
	DownloadingFile = 'Downloading file ...',
	Error = 'Something went wrong! Please try after sometime.',
	FeedbackSuccess = 'Your feedback has been submitted successfully',
	FeedbackError = 'Oops, we encountered an error while submitting your feedback. Please try again after sometime',
	SendingInvoice = 'Sending Payment Link ...',
	DeletingInvoice = 'Deleting Payment Request...',
}

/**
 * App Events
 * @class
 */
class AppEvents {
	/**
	 * All Subscriptions
	 * @member subscribers
	 */
	subscribers: AnyRecord;
	constructor() {
		this.subscribers = {};
	}

	/**
	 * publish an event
	 * @function publish
	 * @param {string} event event
	 * @param {...unknown[]} rest rest
	 */
	publish = (event: string, ...rest: unknown[]) => {
		log.info(`[EventBus] event: ${event}`, rest);
		if (_.has(this.subscribers, event)) {
			_.forOwn(_.get(this.subscribers, event), (callback: AnyType) => {
				try {
					// TODO execution context check
					if (_.isFunction(callback)) {
						callback?.(...rest);
					} else {
						throw new Error(`${event} Not a Function`);
					}
				} catch (ex) {
					log.error(`[Eventbus] ${ex}`);
					faro.api.pushLog([`[Eventbus] ${ex}`], { level: LogLevel.ERROR });
				}
			});
		}
	};

	/**
	 * publish an event to show success message on api save
	 * @function publish
	 * @param {React.ReactNode} message message
	 */
	publishApiSuccess = (message?: React.ReactNode) => {
		this.publish(Events.Success, message || Messages.Success);
	};

	/**
	 * publish an event to raise api error
	 * @function publish
	 */
	publishApiError = (params?: IErrorNotificationParams) => {
		this.publish(Events.Api_Error, params);
	};

	/**
	 * publish an event to redirect to a url
	 * @function publishRedirect
	 * @param {string} url url
	 */
	publishRedirect = ({ url, ...rest }: { url: string; [key: string]: AnyType }) => {
		this.publish(Events.Redirect, { url, ...rest });
	};

	/**
	 * Subscribes an event
	 * @function subscribe
	 * @param {event} event event
	 * @param {unknown} callback callback
	 */
	subscribe = (event: string, callback: unknown) => {
		if (!_.isFunction(callback)) {
			log.error(`[Eventbus] ${callback} is not a function`);
			return;
		}

		let listeners = _.get(this.subscribers, event);
		listeners = _.isArray(listeners) ? [...listeners, callback] : [callback];
		_.setWith(this.subscribers, event, listeners, Object);
	};

	/**
	 * Un-subscribes an event
	 * @param {string} event event
	 */
	unsubscribe = (event: string) => {
		_.unset(this.subscribers, event);
	};
}

export default new AppEvents();

export { Events, Messages };
